import Perfil from './Perfil';

export default Perfil;